import React, { Fragment } from 'react';
import logo from '../assets/logo.png';

import { IconHome2, IconId, IconFiles, IconLogout } from '@tabler/icons-react';
import { Tooltip } from 'react-tooltip';
import { NavLink, useNavigate } from 'react-router-dom';
import { getCurrentUser, logOut } from '../utils/Sessions';
import { useLocation } from 'react-router';
import clsx from 'clsx';
import { useQueryClient } from '@tanstack/react-query';
import { BButton } from './ui/generic';

const BSidebar = () => {
  return (
    <aside className="h-[60dvh] border-b-0 border-slate-200 bg-white md:h-screen md:w-20 md:px-5 md:py-8 lg:border-r">
      <div className="flex h-full flex-col justify-between md:items-center">
        <div className="flex flex-col gap-10 md:items-center">
          <div className={'hidden md:block'}>
            <img src={logo} alt="Logo" className="hidden size-10 md:block" />
          </div>
          <nav className="flex flex-col md:gap-6 text-xl text-gray-700 md:items-center">
            <p className={'text-2xl font-semibold text-slate-700 md:hidden'}>Menu</p>
            <Label label="Accueil" to="/" icon={IconHome2} />
            <Label label="Mes infos" to="/mes-infos" icon={IconId} />
            <Label label="Mes Documents" to="/documents" icon={IconFiles} />
          </nav>
        </div>
        <User />
      </div>
    </aside>
  );
};

const Label = ({ label, icon: Icon, to }) => {
  const location = useLocation();
  const isActive = location.pathname === to;
  const id = `${label}-${to}`;

  return (
    <Fragment>
      <Tooltip id={id} className={'hidden md:block'} />
      <NavLink
        to={to}
        data-tooltip-content={label}
        data-tooltip-id={id}
        className={clsx(
          isActive ? 'text-primary-500' : 'text-slate-600',
          'hover:bg-primary-100 hover:text-primary-500 flex items-center gap-4 rounded-lg md:size-10 md:justify-center'
        )}
      >
        {Icon && <Icon className="size-6" />}
        <p className={'md:hidden py-2'}>{label}</p>
      </NavLink>
    </Fragment>
  );
};

const User = () => {
  const { lastname, name } = getCurrentUser();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const onClickLogout = () => {
    logOut();
    queryClient.clear();
    navigate('/login');
  };

  return (
    <div className={'flex w-full justify-between gap-1'}>
      <div
        id="menuUserDropdown"
        className="from-primary-500 via-primary-600 to-primary-700 relative hidden size-10 items-center justify-center overflow-visible rounded-full bg-gradient-to-b md:inline-flex"
      >
        <span className="font-medium text-white">
          {name.charAt(0)} {lastname.charAt(0)}
        </span>
      </div>
      <div className={"md:hidden"}>
        <BButton Icon={IconLogout} icon={IconLogout} label={'Se déconnecter'} onClick={onClickLogout} />
      </div>
      <Tooltip anchorSelect="#menuUserDropdown" clickable variant="light" opacity={1} border="rgba(232, 236, 253, 1)">
        <button className="hover:cursor-pointer" onClick={onClickLogout}>
          Se déconnecter
        </button>
      </Tooltip>
    </div>
  );
};

BSidebar.Label = Label;
BSidebar.User = User;
export default BSidebar;
